<template>
  <div class="calculator min-h-28 container relative">
    <retirement-calculator>
      <LoadingSvg />
    </retirement-calculator>
  </div>
</template>

<script>
import LoadingSvg from "../Atoms/LoadingSvg.vue";

export default {
  components: {
    LoadingSvg,
  },

  setup() {
    // Script is add in the blade template based on the url
    // let script = document.createElement("script");
    // script.setAttribute(
    //   "src",
    //   "https://marcom.vestwell.com/apps/retirement-calculator/bundle.js"
    // );
    // script.setAttribute("defer", "");
    // document.head.appendChild(script);
  },
};
</script>
